import * as React from 'react';
import { SVGProps } from 'react';

export const Garden = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.875 20.6875L4.75 26.3125H8.5C8.99728 26.3125 9.47419 26.51 9.82583 26.8617C10.1775 27.2133 10.375 27.6902 10.375 28.1875V30.0625"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.75 26.3125V30.0625"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.125 20.6875L27.25 26.3125H23.5C23.0027 26.3125 22.5258 26.51 22.1742 26.8617C21.8225 27.2133 21.625 27.6902 21.625 28.1875V30.0625"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.25 26.3125V30.0625"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 15.645V30.0625"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.5752 12.5201C28.8302 12.7748 29.0063 13.0976 29.0826 13.4499C29.1589 13.8022 29.132 14.169 29.0052 14.5063C28.711 15.226 28.209 15.8416 27.5634 16.2747C26.9177 16.7077 26.1576 16.9385 25.3802 16.9376C24.7065 16.936 24.0458 16.7521 23.4682 16.4055C22.8905 16.0589 22.4174 15.5625 22.0989 14.9688C21.8153 15.5029 21.4055 15.9597 20.9052 16.2994C20.405 16.6392 19.8293 16.8516 19.2282 16.9183C18.6272 16.9849 18.0189 16.9038 17.4563 16.6819C16.8938 16.46 16.3939 16.1041 16.0002 15.6451C15.6063 16.103 15.1067 16.458 14.5447 16.6792C13.9827 16.9004 13.3752 16.9812 12.7749 16.9146C12.1746 16.848 11.5996 16.636 11.0997 16.2969C10.5999 15.9578 10.1903 15.502 9.90642 14.9688C9.58797 15.5625 9.11484 16.0589 8.53717 16.4055C7.95951 16.7521 7.29883 16.936 6.62517 16.9376C5.84777 16.9383 5.08776 16.7075 4.44213 16.2744C3.79649 15.8414 3.29449 15.2259 3.00017 14.5063C2.87273 14.1694 2.84504 13.8029 2.92041 13.4507C2.99578 13.0984 3.17102 12.7754 3.42517 12.5201L14.6752 2.48759C14.8493 2.31335 15.056 2.17513 15.2836 2.08083C15.5112 1.98653 15.7551 1.93799 16.0014 1.93799C16.2477 1.93799 16.4917 1.98653 16.7192 2.08083C16.9468 2.17513 17.1535 2.31335 17.3277 2.48759L28.5752 12.5201Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.90625 14.9688L16 1.9375"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0938 14.9688L16 1.9375"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Garden;
